// Investiture
import React from 'react';
import PickandSpeak2025 from '../views/PickandSpeak2025';


const InvestiturePage = () => {
  return <PickandSpeak2025 />;
};

export default InvestiturePage;
